import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import noResultsDark from '@shared/assets/images/cyber/noResultsDark.png';
const NoResults: FC = () => <Wrapper>
    <ImageWrapper>
      <Image src={noResultsDark} className="icon" alt="no results" height={120} width={120} />
    </ImageWrapper>
    <Title>Ничего не найдено</Title>
    <Description>Измените запрос</Description>
  </Wrapper>;
export default NoResults;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w15msqio",
  propsAsIs: false
});
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "i155zwnu",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Title = withTheme(/*#__PURE__*/styled('div')({
  name: "Title",
  class: "ttaw7rx",
  propsAsIs: false,
  vars: {
    "ttaw7rx-0": [_exp()],
    "ttaw7rx-1": [_exp2(), "px"],
    "ttaw7rx-2": [_exp3()],
    "ttaw7rx-3": [_exp4(), "px"],
    "ttaw7rx-4": [_exp5()]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.tertiary;
const Description = withTheme(/*#__PURE__*/styled('div')({
  name: "Description",
  class: "d11wt790",
  propsAsIs: false,
  vars: {
    "d11wt790-0": [_exp6()],
    "d11wt790-1": [_exp7(), "px"],
    "d11wt790-2": [_exp8()],
    "d11wt790-3": [_exp9(), "px"],
    "d11wt790-4": [_exp0()]
  }
}));

require("./NoResults.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./NoResults.tsx");